import React from "react"
import Timeline from "@mui/lab/Timeline"
import TimelineItem from "@mui/lab/TimelineItem"
import TimelineSeparator from "@mui/lab/TimelineSeparator"
import TimelineConnector from "@mui/lab/TimelineConnector"
import TimelineContent from "@mui/lab/TimelineContent"
import Typography from "@mui/material/Typography"
import LiveHelpIcon from "@mui/icons-material/LiveHelp"
import { CircularProgress, Divider } from "@mui/material"
import ReactPlayer from "react-player"

import "./FAQComponent.css"

import { db } from "../../../firebase/firebase_config"
import { collection, getDocs, orderBy, query } from "firebase/firestore"

class FAQComponent extends React.Component {
	state = {
		loading: true,
		faqs: {},
	}

	async componentDidMount() {
		const faqs_ret = await this.getFAQsData()
		this.setState({ loading: false, faqs: faqs_ret })
	}

	getFAQsData = async () => {
		let faqsList = []
		try {
			const faqsCollection = collection(db, "FAQs")
			const q = query(faqsCollection, orderBy("ID", "asc"))
			await getDocs(q).then((snapshot) => {
				snapshot.forEach((doc) => {
					faqsList.push({ ...doc.data(), id: doc.id })
				})
			})
		} catch (error) {
			console.log("Error fetching FAQs firestore data: " + error.message)
		}
		//console.log(faqsList)
		return faqsList
	}

	render() {
		let faqsComponents = <div>Loading...</div>
		const colors = ["warning", "info"]
		if (!this.state.loading) {
			faqsComponents = this.state.faqs.map((faq, indx) => (
				<TimelineItem key={indx}>
					<TimelineSeparator>
						<LiveHelpIcon color={colors[indx % colors.length]} />
						<TimelineConnector />
					</TimelineSeparator>
					<TimelineContent>
						<Typography variant="h4" component="span">
							{faq.TITLE}
						</Typography>
						{faq.CONTENT.map((line, index) => (
							<>
								<br></br>
								<Typography key={index}>{line}</Typography>
							</>
						))}
					</TimelineContent>
				</TimelineItem>
			))
		}
		return (
			<div className="content">
				<Timeline className="timeline" position="alternate">
					{this.state.loading ? <CircularProgress /> : faqsComponents}
				</Timeline>
				<Divider variant="middle" />

				<Typography variant="h5">
					Además, si quieres hacerte una idea de lo que es, los compañeros de{" "}
					<a
						href="https://www.youtube.com/channel/UCIX-XCae0ZZ9cObbcIQBn7A"
						target="_blank"
						rel="noopener noreferrer"
					>
						Sport Spanish TV
					</a>{" "}
					tienen un video estupendo:
				</Typography>
				<ReactPlayer
					className="react-player"
					url="https://youtu.be/ArxEGgC54zU"
					controls
				/>
			</div>
		)
	}
}

export default FAQComponent
